<template>
    <div style="line-height: 1" class="card carde w3-animate-opacity mb-0" :class="fullscreen ? 'laudite-fullscreen' : ''">
        <div class="card-header d-flex justify-content-between align-items-center bg-white" v-if="fullscreen">
            <div>
                <h5 class="strong" >{{ paciente }}</h5>
            </div>
            <div>
                <slot name="buttons"></slot>
                <a href="#" class="btn btn-light btn-sm ml-3" @click.prevent="toggle_fullscreen()">
                    <i class="fas fa-compress-alt" v-if="fullscreen"></i>
                    <i class="fas fa-expand-alt" v-else></i>    
                </a>
            </div>
        </div>
        <iframe
            v-show="url"
            style="width: 100%;" :style="'height: calc(100vh - ' + ( (posx && !fullscreen) ? posx : '65' ) + 'px);'"
            id="laudite"
            scrolling="no"
            allow="microphone"
            :src="url" />

        <!-- src="https://app.laudite.com.br/?company=64552b84954628566c781a8b&user=4f074ba1eebbdd7616151bd32369f7a7ae4edfeb19af5c6af800a96e5d09797c&view=slim&masksScope=onlyCompany&client=undefined" -->

        <az-dispatch ref="dispatchModal" titulo="Salvando informações..." />
        
        <template v-if="!url">
            <az-empty-state />
        </template>
    </div>
</template>

<script>
// import CryptoJS from 'crypto-js';
// import moment from 'moment';
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzDispatch from "../../util/AzDispatch.vue";

export default {
    data() {
        return {
            lauditeUrl: null, 
            laudoL: null,
            lauditeTextChangeTimeout: null,
            // company_token: '64552b84954628566c781a8b', 
        };
    },

    props: ["company_token", "url", "content", "posx", "fullscreen", "paciente"],

    components: {
        AzEmptyState,
        AzDispatch
    },

    methods: {
        /*
        encript(msg) {
            let pass = this.company_token + this.hoje;
            let iv = pass.slice(-16)

            pass = CryptoJS.enc.Utf8.parse(pass);
            iv = CryptoJS.enc.Utf8.parse(iv);

            try {
                var options = { mode: CryptoJS.mode.CBC, iv: iv };
                var json = CryptoJS.AES.encrypt(msg, pass, options);
                return json.ciphertext.toString(CryptoJS.enc.Hex);
            } catch (err) {
                console.error(err);
                return "";
            }
        },

        makeLauditeUrl(userEmail = 'seu.laudite@laudite.com.br') {
            // View slim / full

            const user = this.encript(userEmail)
            const base_url = 'https://app.laudite.com.br/';
            const url = base_url 
                + '?company=' + this.company_token 
                + '&user=' + this.user
                + '&view=full'
                + '&masksScope=onlyCompany'
                + '&client='

            return url
        },
        */

        toggle_fullscreen() {
            this.$emit("toggle");
        },

        setContent() {
            let lauditeIfr = document.getElementById("laudite").contentWindow;
            // let data;

            // data = {
            //     action: "optionalParams",
            //     data: {
            //         examTitle: 'TC CRANIO',
            //         unitService: 'CENTRAL',
            //         age: 12,
            //         gender: 'm',
            //         method: 'ESPECIAL'
            //     }
            // };

            // lauditeIfr.postMessage(data, "https://app.laudite.com.br");

            let data = {
                action: "sendMask",
                data: this.content ? this.content : ''
            };

            // console.log(data);

            // Argumentos do postMessage: data, domínio de destino
            lauditeIfr.postMessage(data, "https://app.laudite.com.br");
        },

        registraEventos() {
            // Atribuir "handler" para o evento "message"
            if (window.addEventListener) {
                window.addEventListener(
                    "message",
                    this.handlePostMessage,
                    false
                );
            } else if (window.attachEvent) {
                // ie8
                window.attachEvent("onmessage", this.handlePostMessage);
            }
        },

        handlePostMessage(evento) {
            if (evento.origin === "https://app.laudite.com.br") {
                // Checar ações da post messagem
                const { action, data } = evento.data;

                // console.log(evento);
                // console.log("action", action, data);

                switch (action) {
                    case "loaded":
                        // console.log("laudite carregado", data);
                        this.setContent();    
                        break;

                    case "beforeAction":
                        if(data && (data.action === "endReport" || data.action === "saveReport" || data.action === "nextReport")) {
                            this.$refs.dispatchModal.show_modal_fixo();
                        }
                        break;

                    case "saveReport":
                    case "endReport":
                        this.$emit("salvarLaudo", {
                            laudite: true,
                            pdf: (evento.data.pdf && evento.data.pdf.base64) ? evento.data.pdf.base64 : null,
                            data: data
                        });

                        setTimeout(() => {
                            this.$refs.dispatchModal.hide_modal();
                        }, 1000);
                        break;

                    case "nextReport":
                        this.$emit("salvarLaudoNext", {
                            laudite: true,
                            pdf: (evento.data.pdf && evento.data.pdf.base64) ? evento.data.pdf.base64 : null,
                            data: data
                        });

                        setTimeout(() => {
                            this.$refs.dispatchModal.hide_modal();
                        }, 1000);
                        break;

                    case "textChange":
                        this.$emit("autoSave", data);
                        // if (this.lauditeTextChangeTimeout == null) {
                        //     this.$emit("autoSave", data);
                        // }
                        break;

                    // case "getHtml":
                    //     this.$emit("autoSaveGetHtml", data);
                    //
                    //     this.lauditeTextChangeTimeout = setTimeout(() => {
                    //         this.lauditeTextChangeTimeout = null;
                    //     }, 2000);
                    //     break;
                
                    default:
                        // console.log(action, data);
                        break;
                }
            }
        },

        imprimirLaudo(laudo) {
            let lauditeIfr = document.getElementById("laudite").contentWindow;
            let data = {
                action: "getHtml",
                data: '*'
            };
            this.laudo = laudo;
            lauditeIfr.postMessage(data, "https://app.laudite.com.br");

        }
    },

    mounted() {
        // "https://app.laudite.com.br/?company=64552b84954628566c781a8b&user=4f074ba1eebbdd7616151bd32369f7a7ae4edfeb19af5c6af800a96e5d09797c&view=slim&masksScope=onlyCompany&client=undefined";

        this.registraEventos();
    },

    destroyed() {
        if (window.addEventListener) {
            window.removeEventListener("message", this.handlePostMessage);
        } else if (window.attachEvent) {
            window.detachEvent("onmessage", this.handlePostMessage);
        }
    }
};
</script>

<style scoped>
.laudite-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 150px;
  overflow: auto;
}
</style>